@import (reference) '../../../../constants/spacing.module.less';

.navigation-panel {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-16;
}

.header {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.header-text {
  color: var(--default--header--text-color--3);
}

.navigation-button-list {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-8;
  overflow: auto;
}
